import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@ui/components/select";
import type { PromptLanguage } from "../types";

interface LanguageSelectorProps {
	value: PromptLanguage;
	onChange: (value: PromptLanguage) => void;
}

export function LanguageSelector({ value, onChange }: LanguageSelectorProps) {
	return (
		<Select value={value} onValueChange={onChange}>
			<SelectTrigger className="w-full h-[54px]">
				<SelectValue placeholder="Select language" />
			</SelectTrigger>
			<SelectContent>
				<SelectItem value="en">English</SelectItem>
				<SelectItem value="es">Español</SelectItem>
				<SelectItem value="fr">Français</SelectItem>
				<SelectItem value="de">Deutsch</SelectItem>
				<SelectItem value="zh-CN">简体中文</SelectItem>
				<SelectItem value="zh-TW">繁體中文</SelectItem>
				<SelectItem value="ko">한국어</SelectItem>
				<SelectItem value="ru">Русский</SelectItem>
				<SelectItem value="ja">日本語</SelectItem>
				<SelectItem value="it">Italiano</SelectItem>
				<SelectItem value="pt">Português</SelectItem>
				<SelectItem value="ar">العربية</SelectItem>
				<SelectItem value="hi">हिन्दी</SelectItem>
				<SelectItem value="tr">Türkçe</SelectItem>
				<SelectItem value="vi">Tiếng Việt</SelectItem>
				<SelectItem value="id">Bahasa Indonesia</SelectItem>
			</SelectContent>
		</Select>
	);
}
